import RadioButton from './RadioButton'

export default RadioButton



// WEBPACK FOOTER //
// ./src/legacy/containers/Forms/components/RadioButton/index.js